import styled from "styled-components";
import {flexCreator} from "../hooks/helpers";

export const Grid = styled.div`
   width: 100%;
   ${flexCreator("start", "start")};
   align-items: ${props => props.align || "flex-start"};
   flex-wrap: wrap;

   .textModal {
      margin: 0;
      font-size: 0.7em;
      margin-top: 1em;
      text-transform: uppercase;
      font-weight: 400;
   }
`;

export const Col = styled.div`
   width: ${props => returnWidth(props.large)};
   ${props => (props.offsetL ? `margin-left:  ${returnWidth(props.offsetL)}` : "")};

   & button {
      width: 100%;
   }
`;

const returnWidth = size => {
   return `${(100 / 12) * size}%`;
};
